export default class {
    
    /*@ngInject*/
    constructor($http, UTIL_URL){
        Object.assign(this, {$http, UTIL_URL});
    }
    
    sendMail(mail){
        return this.$http.post(`${this.UTIL_URL}/sendMail`, mail);
    }
}


// WEBPACK FOOTER //
// ./client/app/contacto-route/contaco.service.js